import {
  GOOGLE_API_LOAD,
  GOOGLE_AUTH2_API,
} from './types';

export const googleApiLoadSuccess = () => ({ type: GOOGLE_API_LOAD.SUCCESS });
export const googleApiLoadFailure = () => ({ type: GOOGLE_API_LOAD.FAILURE });

export const googleAuth2LoadSuccess = () => ({ type: GOOGLE_AUTH2_API.LOAD_SUCCESS });
export const googleAuth2LoadFailure = () => ({ type: GOOGLE_AUTH2_API.LOAD_FAILURE });

export const googleAuth2InitSuccess = () => ({ type: GOOGLE_AUTH2_API.INIT_SUCCESS });
export const googleAuth2InitFailure = () => ({ type: GOOGLE_AUTH2_API.INIT_FAILURE });
